import {shallowEqual} from 'react-redux';
import {assert} from 'assert-ts';
import {useLocalization} from 'localization';
import {isLinkedRoleCodeListId} from 'schemaDefinition';
import type {LinkedRoleCodeListId} from 'schemaDefinition/types/linkTypes';
import {AllCodeListIdsScopeMap} from 'schemaDefinition/types/linkTypes';
import {selectSettingsPreferredLocale} from 'services/settings';
import {useAppSelector} from 'store/hooks';
import {getLinkedRoleCodelist} from 'schemas/links/functions';
import type {CodeListId, CodeListMap} from '../types';
import {selectCodelistFromCache} from '../codelistSelectors';

export function useCodelists(
  codelistIds: (CodeListId | LinkedRoleCodeListId)[],
): CodeListMap {
  const localization = useLocalization();
  const language = useAppSelector(selectSettingsPreferredLocale);

  return useAppSelector(state => {
    return codelistIds.reduce<CodeListMap>((acc, id) => {
      if (AllCodeListIdsScopeMap[id] === 'local') {
        return acc;
      }

      if (isLinkedRoleCodeListId(id)) {
        acc[id] = getLinkedRoleCodelist(id, localization);
        return acc;
      }

      acc[id] = assert(
        selectCodelistFromCache(id, language, state),
        `useCodelists: codelist ${id} not loaded`,
      );

      return acc;
    }, {});
  }, shallowEqual);
}
